export default '0cf1d20'
